import Link from 'next/link'
import { IMG_NAVIGATION_RINGLE_LOGO } from '../../../constants/navigation.constant'
import useLandingNav from '../useLandingNav'

const NavLogo = () => {
  const { lang } = useLandingNav()

  return (
    <Link href={`/${lang}/student/landing/home`}>
      <img className="sm:w-[83px] sm:h-[28px] w-[72px] h-[24px]" src={IMG_NAVIGATION_RINGLE_LOGO} alt="ringle-logo" />
    </Link>
  )
}

export default NavLogo
